module.exports = __webpack_public_path__ + "static/media/about-img-2@2x.b206b1d3.png";